import { Phone, Mail, MapPin, Clock } from "lucide-react";
import SeoHead from "../components/SeoHead";
import ContactForm from "../components/ContactForm";
import { PageHeader } from "./Services";
import { SITE } from "../lib/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SeoHead
        title="Contact — Termite Habitat 33 | Cabinet termites Bordeaux Gironde"
        description={`Contactez Termite Habitat 33 au ${SITE.phone}. Adresse : ${SITE.address}, ${SITE.postalCode} ${SITE.city}. Intervention dans toute la Gironde. Devis 48 h.`}
        canonical={SITE.url + "/contact"}
        keywords={["contact termites Bordeaux", "devis termites Gironde", "téléphone Termite Habitat 33"]}
        breadcrumbs={[
          { name: "Accueil", url: SITE.url + "/" },
          { name: "Contact", url: SITE.url + "/contact" },
        ]}
      />
      <PageHeader
        eyebrow="Contact"
        title="Parlez à un expert de notre cabinet."
        intro="Une suspicion d'infestation ? Un projet de vente ? Nous répondons à toutes vos demandes sous 24 h ouvrées."
      />
      <section className="container-x py-16 grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white border border-[#D5CABD] p-6 rounded-sm">
            <div className="eyebrow mb-3">Coordonnées</div>
            <div className="space-y-4 text-[15px] text-gray-800">
              <a href={`tel:${SITE.phoneRaw}`} className="flex items-start gap-3 hover:text-[#7A2E39]" data-testid="contact-page-call">
                <Phone className="w-5 h-5 mt-0.5 text-[#7A2E39]" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Téléphone</div>
                  <div className="font-serif text-xl">{SITE.phone}</div>
                </div>
              </a>
              <a href={`mailto:${SITE.email}`} className="flex items-start gap-3 hover:text-[#7A2E39]" data-testid="contact-page-email">
                <Mail className="w-5 h-5 mt-0.5 text-[#7A2E39]" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Email</div>
                  <div>{SITE.email}</div>
                </div>
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 mt-0.5 text-[#7A2E39]" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Adresse</div>
                  <div>{SITE.address}<br />{SITE.postalCode} {SITE.city.toUpperCase()}</div>
                  <a
                    href={SITE.googleBusinessUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-1 text-xs text-[#7A2E39] underline underline-offset-4 hover:text-[#5c232b]"
                    data-testid="contact-gbp-link"
                  >
                    Voir sur Google Maps ⭐ 5/5 →
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 mt-0.5 text-[#7A2E39]" />
                <div>
                  <div className="text-xs uppercase tracking-widest text-gray-500">Horaires</div>
                  <div>{SITE.hours}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#E8DCC9]/40 border border-[#D5CABD] p-6 rounded-sm">
            <div className="eyebrow mb-2">Société associée</div>
            <p className="text-sm text-gray-700">
              Pour consulter nos réalisations complètes et nos références : visitez{" "}
              <a
                href={SITE.parentSite}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#7A2E39] underline underline-offset-4"
                data-testid="contact-parent-site"
              >
                {SITE.parentSiteLabel}
              </a>
              .
            </p>
          </div>

          <iframe
            title="Carte d'accès"
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              `${SITE.address}, ${SITE.postalCode} ${SITE.city}, France`
            )}&output=embed`}
            className="w-full h-72 rounded-sm border border-[#D5CABD]"
            loading="lazy"
          />
        </div>

        <div className="lg:col-span-3">
          <ContactForm />
        </div>
      </section>
    </div>
  );
}
